interface ApiErrorShape {
  data?: { message?: string; detail?: string; code?: string };
  detail?: string;
  message?: string;
  status?: number;
}

export function apiErrorStatus(error: unknown): number | undefined {
  if (typeof error === "object" && error !== null) {
    return (error as ApiErrorShape).status;
  }
  return undefined;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === "object" && error !== null) {
    const shaped = error as ApiErrorShape;
    return shaped.data?.message ?? shaped.data?.detail ?? shaped.detail ?? shaped.message ?? fallback;
  }
  return fallback;
}

export function apiErrorCode(error: unknown): string | undefined {
  if (typeof error === "object" && error !== null) {
    const shaped = error as ApiErrorShape;
    return shaped.data?.code;
  }
  return undefined;
}
